import { SimpleZipStorage } from './SimpleZipStorage';

export default SimpleZipStorage;
